<div class="modal-body">
  <h3>
    Are you sure that you want to <strong>Delete</strong> Filter Group:
    {{ filterGroupToBeDeleted?.name }}?
  </h3>
  <p class="ml-3">{{ filterGroupToBeDeleted?.description }}</p>
  <em>
    <small>
      * Once deleted all information regarding grid filters will be lost.
    </small>
  </em>
</div>
<div class="modal-footer">
  <button nf-button ngbAutoFocus (click)="activeModal.dismiss()">Cancel</button>
  <button nf-button="delete" (click)="activeModal.close()"></button>
</div>
